import { Box, Button, Grid, Stack, TextareaAutosize, TextField, Typography } from '@mui/material'
import { useCallback, useState } from 'react'
import { IQuestionV2, MainObject } from '../../store/reports/types'
import FormLayout from '../forms/FormLayout'
import AddIcon from '@mui/icons-material/Add'
import colors from '../../constants/colors'
import ModalTAG from '../ModalTAG'
import CardTAG from '../CardTAG'
import TextInput from '../TextInput'
import { useForm } from 'react-hook-form'
import { vestResolver } from '@hookform/resolvers/vest'
import utils from '../forms/ReportingPartyForm/utils'
import LabelErrorTAG from '../LabelErrorTAG'
import { textAreaStyle } from '../../constants/styleConstants'
import {
  addCustomFields,
  setReporterValues,
  updateCustomField,
} from '../../store/questions/questionsSlice'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../store'
import questionsSelector from '../../store/questions/questionsSelector'
import { findItemByUuid } from '../../store/reports/reportsSlice'

interface IFormQuestion {
  question: IQuestionV2
  answers?: MainObject[]

  victimQuestionId?: number | null
}

const FormQuestion: React.FC<IFormQuestion> = ({ question, answers, victimQuestionId = null }) => {
  const getAnswer = () => {
    if (answers && answers?.length > 0) {
      return findItemByUuid(answers, question?.uuid)
    }
    return useSelector(questionsSelector.answerToNewCaseQuestion(question?.uuid))
  }
  const answer = getAnswer()
  const [openModal, setOpenModal] = useState<boolean>(false)

  const reporterData = useSelector(questionsSelector.newCaseReporter)
  const custom_fields = useSelector(questionsSelector.customFieldsSelector)

  const dispatch = useDispatch<AppDispatch>()

  const addNewTagFormMethods = useForm<any>({
    defaultValues: { newTag: '' },
    mode: 'onChange',
    shouldFocusError: false,
    resolver: vestResolver(utils.newTagFormValidation),
  })
  const {
    register: newTagRegister,
    handleSubmit: newTagHandleSubmit,
    formState: formStateNewTag,
    reset: resetNewTag,
  } = addNewTagFormMethods

  const customFieldOnChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    dispatch(updateCustomField({ title: e.target.name, value: e.target?.value }))
  }

  const renderCustomFields = () => {
    return (
      custom_fields &&
      custom_fields.map((field, index) => {
        return (
          <Box sx={{ width: '100%' }} key={`${field?.title}-${index}`}>
            <LabelErrorTAG label={field.title} />
            <TextareaAutosize
              name={field.title}
              key={field.title}
              value={field?.description}
              style={textAreaStyle}
              minRows={5}
              placeholder={''}
              onChange={customFieldOnChange}
            />
          </Box>
        )
      })
    )
  }

  const openModalHandler = () => {
    setOpenModal(true)
  }

  const addNewTagSubmitHandler = (values: { newTag: string }) => {
    const { newTag } = values

    dispatch(
      addCustomFields({
        custom_fields: [
          ...custom_fields,
          {
            title: newTag,
            description: '',
          },
        ],
      }),
    )
    resetNewTag({ newTag: '' })
    setOpenModal(false)
  }

  const getMessageNewTag = useCallback(
    (field: 'newTag') => {
      if (!formStateNewTag.errors[field]) return ''

      return formStateNewTag.errors[field]!.message
    },
    [formStateNewTag],
  )

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setReporterValues({ field: e.target.name, value: e.target.value }))
  }

  return (
    <>
      {' '}
      <>
        <Grid container xs={12} spacing={2}>
          <Grid item xs={12} sm={12}>
            <FormLayout>
              <Stack>
                <LabelErrorTAG label='Work Site' />
                <TextField
                  value={reporterData?.work_site}
                  onChange={onChange}
                  variant='standard'
                  type={'text'}
                  fullWidth
                  id='work_site'
                  name='work_site'
                />
              </Stack>
              <Stack>
                <LabelErrorTAG label='Work City' />
                <TextField
                  value={reporterData?.city}
                  onChange={onChange}
                  variant='standard'
                  type={'text'}
                  fullWidth
                  id='city'
                  name='city'
                />
              </Stack>
              <Stack>
                <LabelErrorTAG label='Work Country' />
                <TextField
                  value={reporterData?.work_country}
                  onChange={onChange}
                  variant='standard'
                  type={'text'}
                  fullWidth
                  id='work_country'
                  name='work_country'
                />
              </Stack>

              {renderCustomFields()}
              <Button
                variant='outlined'
                startIcon={<AddIcon />}
                sx={{ color: colors.BLACK }}
                onClick={openModalHandler}
              >
                <Typography variant='bodyRegular' color='inherit'>
                  Add Custom Text Field
                </Typography>
              </Button>
            </FormLayout>
          </Grid>
        </Grid>
        <ModalTAG open={openModal}>
          <form onSubmit={newTagHandleSubmit(addNewTagSubmitHandler)}>
            <CardTAG
              title={'Add Custom Field Title'}
              closable={true}
              closeCard={() => {
                setOpenModal(false)
              }}
            >
              <FormLayout>
                <TextInput
                  register={newTagRegister}
                  fieldName={'newTag'}
                  label={'Title'}
                  error={getMessageNewTag('newTag') as string}
                />
                <Button variant='submitFormButton' type='submit'>
                  <Typography variant='bodyBold'>Add</Typography>
                </Button>
              </FormLayout>
            </CardTAG>
          </form>
        </ModalTAG>
      </>
    </>
  )
}

export default FormQuestion
